import Routes from './routes'
import ReducerFuncs from './store'

const Reducers = (reducerObj) => { reducerObj.setup = ReducerFuncs }

export {
  Routes,
  Reducers
}
